import { lazy } from 'react'

export const FolderList = lazy(() => import('./folder/FolderList'))
export const FileList = lazy(() => import('./file/FileList'))
export const Document = lazy(() => import('./document/Document'))